import { z } from 'zod';

const referenceIdSchema = z.string().trim().min(1);
export const crowdexReferenceKindSchema = z.enum(['chat', 'terminal', 'tab', 'artifact', 'app']);
export type CrowdexReferenceKind = z.infer<typeof crowdexReferenceKindSchema>;

export const crowdexInternalToolInputSchemas = {
  crowdex_read_chat_transcript: z.object({
    chatId: referenceIdSchema.describe('Crowdex chat reference id.'),
  }),
  crowdex_read_terminal_output: z.object({
    terminalId: referenceIdSchema.describe('Crowdex terminal reference id.'),
  }),
  crowdex_describe_reference: z.object({
    kind: crowdexReferenceKindSchema,
    id: referenceIdSchema,
  }),
} as const;

export type CrowdexInternalToolName = keyof typeof crowdexInternalToolInputSchemas;

/** Browser-safe name guard shared by AI SDK UI and the server tool registry. */
export function isCrowdexInternalToolName(value: string): value is CrowdexInternalToolName {
  return Object.hasOwn(crowdexInternalToolInputSchemas, value);
}

/** Static Crowdex tools coexist with arbitrary dynamic ACP/MCP tool parts. */
export type CrowdexInternalUITools = {
  [NAME in CrowdexInternalToolName]: {
    input: z.infer<(typeof crowdexInternalToolInputSchemas)[NAME]>;
    output: unknown;
  };
};
